export function formatDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getRelativeDateRange(days: number, end = new Date()): { startDate: string; endDate: string } {
  const start = new Date(end);
  start.setDate(end.getDate() - days);
  return {
    startDate: formatDateInputValue(start),
    endDate: formatDateInputValue(end),
  };
}
